import { ChangeEvent, useEffect, useRef, useState } from "react"
import LoaderComp from "../../loader/Loader"
import SemanticResults from "./SemanticTestResults";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";

function SemanticPage() {
    const [maxRadius, setMaxRadius] = useState(25);
    const [isResult, setIsResult] = useState(false);
    const [selectedOptionQuery, setSelectedOptionQuery] = useState<any>([]);
    const [selectedOptionCity, setSelectedOptionCity] = useState<any>([]);
    const [dataPost, setDataPost] = useState<any>({});
    const radiusInputRef = useRef<HTMLInputElement>(null);

    const handleRadiusChange = (event: ChangeEvent<HTMLInputElement>) => {
        setMaxRadius(Number(event.target.value));
    };

    const handleTypeSelectQuery = (e:any) => {
        setSelectedOptionQuery(e ? e : null);
    };

    const handleTypeSelectCity = (e:any) => {
        setSelectedOptionCity(e ? e : null);
    };

    let dataSearch = {"city_name":selectedOptionCity, 
        "query":selectedOptionQuery, 
        "radius":radiusInputRef.current?.value}

    const handleSearchVector = async() => { 

        if (dataSearch['city_name'] === null || dataSearch['city_name'].length === 0){
        toast.error("Inserire Città",{
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
            })
        return 
        }

        else if ( dataSearch['query'] === null || dataSearch['query'].length  === 0){
        toast.error("Inserire Query",{
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
            })
        return 
        }
        
        dataSearch['city_name'] = dataSearch['city_name'].value;
        dataSearch['query'] = dataSearch['query'].value;
        dataSearch['radius'] = radiusInputRef.current?.value
        setDataPost(dataSearch)
        setIsResult(true);
        }



    useEffect(() => {
          if (radiusInputRef.current) {
            const percentage = ((maxRadius - 0) / (200 - 0)) * 100;
            radiusInputRef.current.style.setProperty("--value", `${percentage}%`);
          }
        }, [maxRadius]);
    return (
        <div>
            {isResult?
            <div>
                <SemanticResults dataPost={dataPost} setIsResult={setIsResult}></SemanticResults>
            </div>
            :
            <div className="center-div">
                <div className="filter">
                    <p className="bold">Query Ricerca <strong style={{ color: '#DA291C' }}>*</strong></p>
                    <div style={{marginTop:"5%",marginBottom:"20%"}}>
                        <CreatableSelect 
                        value={selectedOptionQuery}
                        onChange={handleTypeSelectQuery}
                        className="basic-single"
                        classNamePrefix="select"
                        placeholder = "Inserisci query ricerca"
                        isDisabled={false}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={true}
                        />
                    </div>
                    <p className="bold">Inserisci Città <strong style={{ color: '#DA291C' }}>*</strong></p>
                    <div style={{marginTop:"5%",marginBottom:"20%"}}>
                        <CreatableSelect 
                        value={selectedOptionCity}
                        onChange={handleTypeSelectCity}
                        className="basic-single"
                        classNamePrefix="select"
                        placeholder="Inserisci città"
                        isClearable={true}
                        isSearchable={true}
                        isDisabled={false}
                        />
                    </div>
                    <p className="bold">Distanza</p>
                    <div style={{marginTop:"5%",marginBottom:"20%"}}>
                        <div id="radius-selector">
                            <p className="bold"></p>
                            <p>{maxRadius} km</p>
                            <input
                            type="range"
                            id="radius"
                            name="radius"
                            min="0"
                            max="200"
                            step="5"
                            value={maxRadius}
                            onChange={handleRadiusChange}
                            ref={radiusInputRef}
                            />
                        </div>
                    </div>
                    <div className="button-position">
                        <button className="cta-red-realtime" onClick={handleSearchVector}>
                                {"Lancia Semantic Search"}
                        </button>
                    </div>
                </div>
            </div>}
        </div>
    )
}

export default SemanticPage

